<div class="detail-footer" data-testid="job-detail-footer-container">
  <div class="progress-bar" [style.width.%]="getProgressPercent()" data-testid="job-detail-footer-progress-bar"></div>
  <div class="info">
    <div class="pending-completed-indicator" [hidden]="getProgressPercent() == 100" data-testid="job-detail-footer-progress-indicator">
      <span class="completed-issues" data-testid="job-detail-footer-completed-count">{{completedItems}}</span>
      <a class="total-issues" data-testid="job-detail-footer-total-count"> / {{totalItems}} Complete</a>
    </div>
    <button class="action-button" [disabled]="getProgressPercent() < 100"
      (click)="buttonClick()" data-testid="job-detail-footer-btn-action">{{buttonText}}</button>
  </div>
</div>
